import React, { useReducer } from "react";
import WidgetContext from "./widgetContext";
import WidgetReducer from "./widgetReducer";

import clienteAxios from "../../service/axios";

import {
  OBTENER_WIDGETS,
  AGREGAR_WIDGET,
  ELIMINAR_WIDGET,
  ACTUALIZAR_WIDGET,
  WIDGET_ERROR,
  WIDGET_OK,
  WIDGET_ACTUAL,
  OBTENER_WIDGET,
} from "types/context";

const WidgetState = (props) => {
  const initialState = {
    widgets: [], // widgets del cliente/dashboard
    widget: null,
    cliente: null,
    loading: true,
    errorformulario: false,
    mensaje: null,
  };

  const [state, dispatch] = useReducer(WidgetReducer, initialState);

  // Obtener los Widgets
  const obtenerWidgets = async (clienteId) => {
    try {
      // siempre deberia venir un cliente
      let resultado;
      if (clienteId) {
        resultado = await clienteAxios.get(`/widgets?clienteId${clienteId}`);
      } 
      //console.log(resultado);
      dispatch({
        type: OBTENER_WIDGETS,
        payload: resultado.data.widgets,
      });
      return {
        data: resultado.data.widgets,
        page: resultado.data.pagina - 1,
        totalCount: resultado.data.totalRegistros,
      };
    } catch (error) {
      const alerta = {
        msg: error.response.data.message,
        categoria: "error",
      };
      dispatch({
        type: WIDGET_ERROR,
        payload: alerta,
      });
    }
  };

  // Agregar nuevo widget
  const agregarWidget = async (widget) => {
    try {
      const resultado = await clienteAxios.post("/widgets", widget);
      //console.log(resultado);
      // Insertar el widget en el estado
      dispatch({
        type: AGREGAR_WIDGET,
        payload: resultado.data.widget,
      });

      const alerta = {
        msg: "Widget grabado con éxito",
        categoria: "exito",
      };
      dispatch({
        type: WIDGET_OK,
        payload: alerta
    })
    return resultado.status
    } catch (error) {
      const alerta = {
        msg: error.response.data.message,
        categoria: "error",
      };

      dispatch({
        type: WIDGET_ERROR,
        payload: alerta,
      });
    }
  };
  // Selecciona el widget que el usuario dio click
  const widgetActual = (widgetId) => {
    dispatch({
      type: WIDGET_ACTUAL,
      payload: widgetId,
    });
  };

  // Elimina un widget
  const eliminarWidget = async (widgetId) => {
    try {
      await clienteAxios.delete(`/widgets/${widgetId}`);
      dispatch({
        type: ELIMINAR_WIDGET,
        payload: widgetId,
      });
      const alerta = {
        msg: "Widget eliminado con éxito",
        categoria: "exito",
      };
      dispatch({
        type: WIDGET_OK,
        payload: alerta
    })
    } catch (error) {
      const alerta = {
        msg: error.response.data.message,
        categoria: "error",
      };

      dispatch({
        type: WIDGET_ERROR,
        payload: alerta,
      });
    }
  };

  // Aactualizar widget
  const actualizarWidget = async (widget) => {
    try {
      const resultado = await clienteAxios.put(`/widgets/${widget.id}`, widget);
      //console.log(resultado);
      // Actualizo el disp en el state
      dispatch({
        type: ACTUALIZAR_WIDGET,
        payload: resultado.data.widget,
      });
      const alerta = {
        msg: "Widget actualizado con éxito",
        categoria: "exito",
      };
      dispatch({
        type: WIDGET_OK,
        payload: alerta
    })
    } catch (error) {
      console.log(error);
      const alerta = {
        msg: error?.response?.data?.message || "Error al actualizar",
        categoria: "error",
      };

      dispatch({
        type: WIDGET_ERROR,
        payload: alerta,
      });
    }
  };

  // muestra un error de validacion
  const errorWidget = (msj, categoria) => {
    const alerta = {
      msg: msj,
      categoria: categoria,
    };
    dispatch({
      type: WIDGET_ERROR,
      payload: alerta,
    });
  };

  // muestra un error de validacion
  const clearErrorWidget = () => {
    dispatch({
      type: WIDGET_ERROR,
      payload: null,
    });
  };

  // muestra un error de validacion
  const okWidget = (msj, categoria) => {
    const alerta = {
      msg: msj,
      categoria: categoria,
    };
    dispatch({
      type: WIDGET_OK,
      payload: alerta,
    });
  };

  // muestra un error de validacion
  const clearOkWidget = () => {
    dispatch({
      type: WIDGET_OK,
      payload: null,
    });
  };

  // Obtengo un widget por id
  const obtenerWidget = async (widgetId) => {
    try {
      const resultado = await clienteAxios.get(`/widget/${widgetId}`);

      dispatch({
        type: OBTENER_WIDGET,
        payload: resultado.data.widget,
      });
      return resultado.data.widget;
    } catch (error) {
      const alerta = {
        msg: error.response.data.message,
        categoria: "error",
      };
      dispatch({
        type: WIDGET_ERROR,
        payload: alerta,
      });
    }
  };

  return (
    <WidgetContext.Provider
      value={{
        widgets: state.widgets,
        widget: state.widget,
        cliente: state.cliente,
        loading: state.loading,
        errorformulario: state.errorformulario,
        mensaje: state.mensaje,
        obtenerWidgets,
        agregarWidget,
        widgetActual,
        eliminarWidget,
        actualizarWidget,
        errorWidget,
        okWidget,
        obtenerWidget,
        clearErrorWidget,
        clearOkWidget,
      }}
    >
      {props.children}
    </WidgetContext.Provider>
  );
};
export default WidgetState;
